import { Checkbox, CheckboxField } from '@oysterjs/ui/checkbox';
import { Label } from '@oysterjs/ui/fieldset';
import { OutboundVoiceComplianceDisclosureFieldsFragment } from '~/api/graphql';

type OutboundVoiceComplianceNoticeProps = {
  disclosure: OutboundVoiceComplianceDisclosureFieldsFragment;
  acknowledged: boolean;
  onAcknowledgedChange: (acknowledged: boolean) => void;
  disabled?: boolean;
};

/** Renders the versioned outbound-voice compliance disclosure and acknowledgment checkbox. */
export const OutboundVoiceComplianceNotice = ({
  disclosure,
  acknowledged,
  onAcknowledgedChange,
  disabled
}: OutboundVoiceComplianceNoticeProps) => {
  return (
    <div className="space-y-4">
      <p className="text-sm text-neutral-600 dark:text-neutral-400 whitespace-pre-line">
        {disclosure.intro}
      </p>
      <div className="max-h-80 space-y-4 overflow-y-auto rounded-md border border-neutral-200 dark:border-neutral-700 bg-neutral-50 dark:bg-neutral-900 p-4">
        {disclosure.sections.map((section) => (
          <div key={section.heading} className="space-y-2">
            <h4 className="m-0 text-sm font-semibold text-neutral-900 dark:text-white">
              {section.heading}
            </h4>
            {section.body.split('\n\n').map((paragraph, index) => (
              <p key={index} className="m-0 text-sm text-neutral-700 dark:text-neutral-300">
                {paragraph}
              </p>
            ))}
          </div>
        ))}
      </div>
      <CheckboxField disabled={disabled}>
        <Checkbox
          color="sky"
          checked={acknowledged}
          onChange={(checked: boolean) => onAcknowledgedChange(checked)}
        />
        <Label>{disclosure.acknowledgmentLabel}</Label>
      </CheckboxField>
    </div>
  );
};
